<style lang="less">
    .shape-context {
        min-width: 200px;
        max-width: 500px;
    }
    .org-shape-content {
        min-width: 200px !important;
    }
</style>
<i18n>
{
  "zh": {
    "openLibFromShape": "打开符号所在库",
    "drillText": "上钻",
    "toggleText": "缩略",
    "stopDrillText": "取消上钻",
    "stopToggleText": "取消缩略",
    "copyText": "复制",
    "cutText": "剪切",
    "pasteText": "粘贴",
    "delText": "删除",
    "styleBrush": "格式刷",
    "AI": "AI助手",
    "pictureAnalysis": "图片分析",
    "aiChart": "图表分析",
    "aiTable": "表格分析",
    "aiImage": "AI绘画",
    "aiOrgShape": "组织结构图分析",
    "aiFlowchart": "流程图分析",
    "aiTextFlowchart": "亿图AI",
    "group": "组合",
    "lockShape": "锁定选中",
    "protect": "锁定",
    "unprotect": "解除锁定",
    "unGroup": "解除组合",
    "replaceShape": "替换形状",
    "clearWatermark": "去水印",
    "layer": "层级",
    "moveLayer": "移动到图层",
    "align": "对齐",
    "distribute": "分布",
    "sameSize": "等大小",
    "insert": "插入",
    "shapeData": "形状数据",
    "HFlip": "水平翻转",
    "VFlip": "垂直翻转",
    "RSCnt": "重置连接线",
    "RACnt": "直角连接线",
    "SLCnt": "直线连接线",
    "CurveCnt": "曲线连接线",
    "OrgPhoto": "替换照片",
    "clickEvent": "点击事件",
    "sendToNewPage": "发送到新页面",
    "moveUpLane": "上移泳道",
    "moveDownLane": "下移泳道",
    "moveLeftLane": "左移泳道",
    "moveRightLane": "右移泳道",
    "insertLaneBefore": "向前插入泳道",
    "insertLaneAfter": "向后插入泳道",
    "deleteLane": "删除泳道",
    "deleteSeparator": "删除分隔符",
    "showSwimMainTitle": "显示泳道图主标题",
    "mergeBlock": "组合块",
    "HSplit": "水平分割",
    "VSplit": "竖直分割",
    "expandAllSubTask": "展开所有子任务",
    "collapseAllSubTask": "隐藏所有子任务",
    "moveTasksUp": "向上移动任务",
    "moveTasksDown": "向下移动任务",
    "addSymbolToLibs": "添加到我的符号库"
  },
  "en": {
    "openLibFromShape": "Open Library",
    "drillText": "Drill Up",
    "toggleText": "Drill Down",
    "stopDrillText": "Cancel Drill UP",
    "stopToggleText": "Cancel Drill Down",
    "copyText": "Copy",
    "cutText": "Cut",
    "pasteText": "Paste",
    "delText": "Delete",
    "styleBrush": "Style Brush",
    "AI": "AI Assist",
    "pictureAnalysis": "Picture Analysis",
    "aiChart": "Chart Analysis",
    "aiTable": "Table Analysis",
    "aiImage": "AI Drawing",
    "aiOrgShape": "Organizational Chart Analysis",
    "aiFlowchart": "Flowchart Analysis",
    "aiTextFlowchart": "Edraw AI",
    "group": "Group",
    "lockShape": "Lock Selected Shape",
    "protect": "Locked",
    "unprotect": "UnLock",
    "unGroup": "Ungroup",
    "replaceShape": "Replace Shape",
    "layer": "Layer",
    "moveLayer": "Move to Layer",
    "align": "Align",
    "distribute": "Distribution",
    "sameSize": "Same Size",
    "insert": "Insert",
    "shapeData": "Shape Data",
    "HFlip": "Horizontal Flip",
    "VFlip": "Vertical Flip",
    "RSCnt": "Reset Connector",
    "RACnt": "Convert to Right-Angle Connector ",
    "SLCnt": "Convert to Straight Connector ",
    "CurveCnt": "Convert to Curved Connector ",
    "OrgPhoto": "Change Photo",
    "clickEvent": "Click Events",
    "sendToNewPage": "Send to New Page",
    "moveUpLane": "Move Up Lane",
    "moveDownLane": "Move Down Lane",
    "moveLeftLane": "Move Left Lane",
    "moveRightLane": "Move Right Lane",
    "insertLaneBefore": "Insert Lane Before",
    "insertLaneAfter": "Insert Lane After",
    "deleteLane": "Delete Lane",
    "deleteSeparator": "Remove Separator",
    "showSwimMainTitle": "Display the main title of the swim lane chart",
    "mergeBlock": "Merge Blocks",
    "HSplit": "Split Horizontally",
    "VSplit": "Split Vertically",
    "expandAllSubTask": "Expand all subtasks",
    "collapseAllSubTask": "Collapse All SubTasks",
    "moveTasksUp": "Move tasks up",
    "moveTasksDown": "Move tasks down",
    "addSymbolToLibs": "Add to my library",
    "clearWatermark": "Remove watermarks"
  },
  "fr": {
    "openLibFromShape": "Ouvrir la bibliothèque de symboles",
    "drillText": "Monter dans une hiérarchie",
    "toggleText": "Descendre dans une hiérarchie",
    "stopDrillText": "Descendre dans une hiérarchie",
    "stopToggleText": "Monter dans une hiérarchie",
    "copyText": "Copier",
    "cutText": "Couper",
    "pasteText": "Coller",
    "delText": "Supprimer",
    "styleBrush": "Style de brosse",
    "AI": "Assistance IA",
    "pictureAnalysis": "Analyse d'image",
    "aiChart": "Analyse de graphique",
    "aiTable": "Analisi tabella",
    "aiImage": "Dessin AI",
    "aiOrgShape": "Analyse d'organigramme hiérarchique",
    "aiFlowchart": "Analyse d'organigramme",
    "aiTextFlowchart": "IA Edraw",
    "group": "Grouper",
    "lockShape": "Déverrouiller la sélection",
    "protect": "Protéger",
    "unprotect": "Débloquer",
    "unGroup": "Dissocier",
    "replaceShape": "Remplacer la forme",
    "layer": "Couche",
    "moveLayer": "Déplacer vers",
    "align": "Aligner",
    "distribute": "Distribuer",
    "sameSize": "Même taille",
    "insert": "Insérer",
    "shapeData": "Données de forme",
    "HFlip": "Flip horizontal",
    "VFlip": "Flip vertical",
    "RSCnt": "Réinitialiser le connecteur",
    "RACnt": "Ligne à angle droit",
    "SLCnt": "Ligne droite",
    "CurveCnt": "Ligne de liaison courbe",
    "OrgPhoto": "Remplacer la photo",
    "clickEvent": "Événements de clic",
    "sendToNewPage": "Envoyer à une nouvelle page",
    "moveUpLane": "Déplacer la voie vers le haut",
    "moveDownLane": "Déplacer la voie vers le bas",
    "moveLeftLane": "Déplacer la voie vers la gauche",
    "moveRightLane": "Déplacer la voie vers la droite",
    "insertLaneBefore": "Insérer une voie avant",
    "insertLaneAfter": "Insérer une voie après",
    "deleteLane": "Supprimer la voie",
    "deleteSeparator": "Supprimer le séparateur",
    "mergeBlock": "Bloc combiné",
    "showSwimMainTitle": "Afficher le titre principal du graphique des couloirs de nage",
    "HSplit": "Segmentation Horizontale",
    "VSplit": "Segmentation Verticale",
    "expandAllSubTask": "Nascondi tutte le attività secondarie",
    "collapseAllSubTask": "Nascondi tutte le attività secondarie",
    "moveTasksUp": "Déplacer la tâche vers le haut",
    "moveTasksDown": "Déplacer la tâche vers le bas",
    "addSymbolToLibs": "Ajouter à collection",
    "clearWatermark": "Supprimer les filigranes"
  },
  "de": {
    "openLibFromShape": "Bibliothek öffnen",
    "drillText": "Aufbohren",
    "toggleText": "Herunterziehen",
    "stopDrillText": "Aufbohren abbrechen",
    "stopToggleText": "Herunterziehen abbrechen",
    "copyText": "Kopieren",
    "cutText": "Abschneiden",
    "pasteText": "Einfügen",
    "delText": "Löschen",
    "styleBrush": "Format übertragen",
    "AI": "KI-Assistenz",
    "pictureAnalysis": "Bildanalyse",
    "aiChart": "Diagrammanalyse",
    "aiTable": "Tabellenanalyse",
    "aiImage": "AI Drawing",
    "aiOrgShape": "Organigramm-Analyse",
    "aiFlowchart": "Flussdiagramm-Analyse",
    "aiTextFlowchart": "Edraw AI",
    "group": "Gruppe",
    "lockShape": "Ausgewählte Form sperren",
    "protect": "Schützen",
    "unprotect": "Entsperren",
    "unGroup": "Gruppe aufheben",
    "replaceShape": "Form ersetzen",
    "layer": "Ebene ",
    "moveLayer": "In Ebene verschieben",
    "align": "Ausrichten ",
    "distribute": "Verteilung ",
    "sameSize": "Gleiche Größe",
    "insert": "Einfügen",
    "shapeData": "Datenformat",
    "HFlip": "Horizontal Flip",
    "VFlip": "Vertikal Flip",
    "RSCnt": "In rechtwinkligen Anschluss konvertieren",
    "RACnt": "In gerade Verbindung umwandeln",
    "SLCnt": "In gerade Verbindung umwandeln",
    "CurveCnt": "In gebogene Verbindung konvertieren",
    "OrgPhoto": "Foto wechseln",
    "clickEvent": "Ereignisse anklicken",
    "sendToNewPage": "An neue Seite senden",
    "moveUpLane": "Spur hochziehen",
    "moveDownLane": "Spur herunterziehen",
    "moveLeftLane": "Spur nach links ziehen",
    "moveRightLane": "Spur nach rechts ziehen",
    "insertLaneBefore": "Spur vorn einfügen,",
    "insertLaneAfter": "Spur hinten einfügen",
    "deleteLane": "Spur löschen",
    "deleteSeparator": "Trennzeichen entfernen",
    "mergeBlock": "Blöcke zusammenführen",
    "showSwimMainTitle": "Zeigen Sie den Haupttitel der Schwimmspurkarte an",
    "HSplit": "Horizonal splitten",
    "VSplit": "Vertikal splitten",
    "expandAllSubTask": "Expandieren Sie alle Unteraufgaben",
    "collapseAllSubTask": "Verbergen Sie alle Unteraufgeben",
    "moveTasksUp": "Aufgaben nach oben verschieben",
    "moveTasksDown": "Aufgaben nach unten verschieben",
    "addSymbolToLibs": "Meiner Sammlung hinzufügen",
    "clearWatermark": "Wasserzeichen entfernen"
  },
  "jp": {
    "openLibFromShape": "図形ライブラリを開く",
    "drillText": "ドリル",
    "toggleText": "トグル",
    "stopDrillText": "ドリル解除",
    "stopToggleText": "トグル解除",
    "copyText": "コピー",
    "cutText": "切り取り",
    "pasteText": "貼り付け",
    "delText": "削除",
    "styleBrush": "書式のコピー/貼り付け",
    "AI": "AIアシスト",
    "pictureAnalysis": "画像解析",
    "aiChart": "チャート分析",
    "aiTable": "テーブル分析",
    "aiImage": "AI描画",
    "aiOrgShape": "組織図分析",
    "aiFlowchart": "フローチャートの分析",
    "aiTextFlowchart": "Edraw AI",
    "group": "グループ化",
    "lockShape": "ロック",
    "protect": "ロック",
    "unprotect": "ロック解除",
    "unGroup": "グループ化解除",
    "replaceShape": "図形を置換",
    "layer": "レイヤー",
    "moveLayer": "レイヤーに移動",
    "align": "並び替え",
    "distribute": "配置",
    "sameSize": "同じサイズ",
    "insert": "挿入",
    "shapeData": "図形データ",
    "HFlip": "水平回転",
    "VFlip": "垂直回転",
    "RSCnt": "関連線をリセット",
    "RACnt": "直角コネクターに変換",
    "SLCnt": "直線コネクターに変換",
    "CurveCnt": "曲線コネクターに変換",
    "OrgPhoto": "写真を置換",
    "clickEvent": "クリックイベント",
    "sendToNewPage": "新しいページに送る",
    "moveUpLane": "スイムレーンを上に移動",
    "moveDownLane": "スイムレーンを下に移動",
    "moveLeftLane": "スイムレーンを左に移動",
    "moveRightLane": "スイムレーンを右に移動",
    "insertLaneBefore": "スイムレーンを前に追加",
    "insertLaneAfter": "スイムレーンを後ろに追加",
    "deleteLane": "スイムレーンを削除",
    "deleteSeparator": "セパレーターを取り外します",
    "showSwimMainTitle": "スイムレーンチャートのメインタイトルを表示する",
    "mergeBlock": "コンボブロック",
    "HSplit": "水平分割",
    "VSplit": "垂直分割",
    "expandAllSubTask": "すべてのサブタスクを展開します",
    "collapseAllSubTask": "すべてのサブタスクを非表示",
    "moveTasksUp": "タスクを上に移動",
    "moveTasksDown": "タスクを下に移動",
    "addSymbolToLibs": "気に入りに追加",
    "clearWatermark": "透かしを削除"
  },
  "es": {
    "openLibFromShape": "Biblioteca abierta",
    "drillText": "Taladrar",
    "toggleText": "Minimizar",
    "stopDrillText": "Cancelar taladrar",
    "stopToggleText": "Cancelar minimizar",
    "copyText": "Copia",
    "cutText": "Cortar",
    "pasteText": "Pegar",
    "delText": "Eliminar",
    "styleBrush": "Cepillo de estilo",
    "AI": "Asistencia IA",
    "pictureAnalysis": "Análisis de imágenes",
    "aiChart": "Análisis de diagrama",
    "aiTable": "Análisis de tabla",
    "aiImage": "Dibujo de AI",
    "aiOrgShape": "Análisis de organigrama",
    "aiFlowchart": "Análisis de diagrama de flujo",
    "aiTextFlowchart": "IA de Edraw",
    "group": "Grupo",
    "lockShape": "Bloquear la forma seleccionada",
    "protect": "Proteger",
    "unprotect": "Desbloquear",
    "unGroup": "Desagrupar",
    "replaceShape": "Reemplazar la forma",
    "layer": "Capa",
    "moveLayer": "Mover a la capa",
    "align": "Alinear",
    "distribute": "Distribución",
    "sameSize": "Mismo tamaño",
    "insert": "Insertar",
    "shapeData": "Datos de la forma",
    "HFlip": "Volteo horizontal",
    "VFlip": "Volteo vertical",
    "RSCnt": "Conector de reajuste",
    "RACnt": "Convertir a conector en ángulo recto ",
    "SLCnt": "Convertir a conector recto ",
    "CurveCnt": "Convertir a conector curvo ",
    "OrgPhoto": "Cambiar la foto",
    "clickEvent": "Haga clic en Eventos",
    "sendToNewPage": "Enviar a la nueva página",
    "moveUpLane": "Moverse por el carril de arriba",
    "moveDownLane": "Moverse por el carril",
    "moveLeftLane": "Mover el carril izquierdo",
    "moveRightLane": "Moverse por el carril derecho",
    "insertLaneBefore": "Insertar el carril antes",
    "insertLaneAfter": "Inserte el carril después",
    "deleteLane": "Borrar el carril",
    "deleteSeparator": "Quitar separador",
    "mergeBlock": "Fusión de bloques",
    "showSwimMainTitle": "Mostrar el título principal del gráfico de carriles de natación",
    "HSplit": "Dividido horizontalmente",
    "VSplit": "Dividido verticalmente",
    "expandAllSubTask": "Expandir todas las subtareas",
    "collapseAllSubTask": "Ocultar todas las subtareas",
    "moveTasksUp": "Subir tarea",
    "moveTasksDown": "Bajar tarea",
    "addSymbolToLibs": "Añadir a mi colección",
    "clearWatermark": "Eliminación de marcas de agua"
  },
  "pt": {
    "openLibFromShape": "Abrir Biblioteca",
    "drillText": "Afastar",
    "toggleText": "Aproximar",
    "stopDrillText": "Cancelar Afastar",
    "stopToggleText": "Cancelar Aproximar",
    "copyText": "Copiar",
    "cutText": "Cortar",
    "pasteText": "Colar",
    "delText": "Eliminar",
    "styleBrush": "Escova de Estilo",
    "AI": "Assistência IA",
    "pictureAnalysis": "Análise de imagem",
    "aiChart": "Análise de gráficos",
    "aiTable": "Análise de tabela",
    "aiImage": "Desenho por IA",
    "aiOrgShape": "Análise de organograma",
    "aiFlowchart": "Análise de fluxograma",
    "aiTextFlowchart": "IA do Edraw",
    "group": "Agrupar",
    "lockShape": "Bloquear Forma Selecionada",
    "protect": "Bloqueado",
    "unprotect": "Desbloquear",
    "unGroup": "Desagrupar",
    "replaceShape": "Substituir Forma",
    "layer": "Camada",
    "moveLayer": "Mover para Camada",
    "align": "Alinhar",
    "distribute": "Distribuição",
    "sameSize": "Mesmo Tamanho",
    "insert": "Inserir",
    "shapeData": "Dados de Forma",
    "HFlip": "Virar Horizontal",
    "VFlip": "Virar Vertical",
    "RSCnt": "Repor Conector",
    "RACnt": "Converter para Conector de Ângulo Direito",
    "SLCnt": "Converter para Conector Reto",
    "CurveCnt": "Converter para Conector Curvo",
    "OrgPhoto": "Alterar Fotografia",
    "clickEvent": "Clicar em Eventos",
    "sendToNewPage": "Enviar para Nova Página",
    "moveUpLane": "Mover Faixa para Cima",
    "moveDownLane": "Mover Faixa para Baixo",
    "moveLeftLane": "Mover Faixa para Esquerda",
    "moveRightLane": "Mover Faixa para Direita",
    "insertLaneBefore": "Inserir Faixa Antes",
    "insertLaneAfter": "Inserir Faixa Depois",
    "deleteLane": "Eliminar Faixa",
    "deleteSeparator": "Remover o Separador",
    "mergeBlock": "Unir Blocos",
    "showSwimMainTitle": "Exibir o título principal do gráfico da raia",
    "HSplit": "Dividir Horizontalmente",
    "VSplit": "Dividir Verticalmente",
    "expandAllSubTask": "Expanda todas as subtarefas",
    "collapseAllSubTask": "Esconder todas as subtarefas",
    "moveTasksUp": "Mover tarefa para cima",
    "moveTasksDown": "Mover tarefa para baixo",
    "addSymbolToLibs": "Adicionar à minha coleção",
    "clearWatermark": "Remover marcas d'água"
  },
  "it": {
    "openLibFromShape": "Apri Libreria",
    "drillText": "Drill Up",
    "toggleText": "Drill Down",
    "stopDrillText": "Elimina Drill Up",
    "stopToggleText": "Elimina Drill Down",
    "copyText": "Copia",
    "cutText": "Taglia",
    "pasteText": "Incolla",
    "delText": "Elimina",
    "styleBrush": "Stile Pennello",
    "AI": "Assistenza IA",
    "pictureAnalysis": "Analisi immagine",
    "aiChart": "Analisi grafico",
    "aiTable": "Analisis Tabel",
    "aiImage": "Disegno AI",
    "aiOrgShape": "Analisi organigramma",
    "aiFlowchart": "Analisi diagramma di flusso",
    "aiTextFlowchart": "Edraw AI",
    "group": "Raggruppa",
    "lockShape": "Blocca Forma Selezionata",
    "protect": "Bloccato",
    "unprotect": "Sblocca",
    "unGroup": "Separa",
    "replaceShape": "Sostituisci Forma",
    "layer": "Livello",
    "moveLayer": "Sposta su Livello",
    "align": "Allinea",
    "distribute": "Distribuzione",
    "sameSize": "Stessa Dimensione",
    "insert": "Inserisci",
    "shapeData": "Dati Forma",
    "HFlip": "Capovolgi Orizzontalmente",
    "VFlip": "Capovolgi Verticalmente",
    "RSCnt": "Reimposta Connettore",
    "RACnt": "Converti in Connettore ad Angolo",
    "SLCnt": "Converti in Connettore Dritto",
    "CurveCnt": "Converti in Connettore Curvo",
    "OrgPhoto": "Cambia Foto",
    "clickEvent": "Evento Click",
    "sendToNewPage": "Invia a Nuova Pagina",
    "moveUpLane": "Sposta Corsia Su",
    "moveDownLane": "Sposta Corsia Giù",
    "moveLeftLane": "Sposta Corsia a Sinistra",
    "moveRightLane": "Sposta Corsia a Destra",
    "insertLaneBefore": "Inserisci Corsia Prima",
    "insertLaneAfter": "Inserisci Corsia Dopo",
    "deleteLane": "Elimina Corsia",
    "deleteSeparator": "Rimuovi separatore",
    "mergeBlock": "Unisci Blocchi",
    "showSwimMainTitle": "Visualizza il titolo principale della mappa delle corsie di nuoto",
    "HSplit": "Dividi Orizzontalmente",
    "VSplit": "Dividi Verticalmente",
    "expandAllSubTask": "Espandi tutte le attività secondarie",
    "collapseAllSubTask": "Nascondi tutte le attività secondarie",
    "moveTasksUp": "Sposta l'attività in alto",
    "moveTasksDown": "Sposta l'attività in basso",
    "addSymbolToLibs": "Aggiungi alla mia raccolta",
    "clearWatermark": "Rimuovi filigrana"
  },
  "tw": {
    "openLibFromShape": "打開符號所在庫",
    "drillText": "上磚",
    "toggleText": "縮略",
    "stopDrillText": "取消上磚",
    "stopToggleText": "取消縮略",
    "copyText": "複製",
    "cutText": "剪下",
    "pasteText": "貼上",
    "delText": "刪除",
    "styleBrush": "格式刷",
    "AI": "AI協助",
    "pictureAnalysis": "圖片分析",
    "aiChart": "圖表分析",
    "aiTable": "表格分析",
    "aiImage": "AI 繪圖",
    "aiOrgShape": "組織圖分析",
    "aiFlowchart": "流程圖分析",
    "aiTextFlowchart": "Edraw AI",
    "group": "組合",
    "lockShape": "鎖定選中",
    "unGroup": "解除組合",
    "replaceShape": "替換形狀",
    "layer": "層級",
    "moveLayer": "移動到圖層",
    "align": "對齊",
    "distribute": "分佈",
    "sameSize": "等大小",
    "insert": "插入",
    "shapeData": "形狀數據",
    "HFlip": "水平翻轉",
    "VFlip": "垂直翻轉",
    "RSCnt": "重置連接線",
    "RACnt": "直角連接線",
    "SLCnt": "直線連接線",
    "CurveCnt": "曲線連接線",
    "OrgPhoto": "替換照片",
    "clickEvent": "點擊事件",
    "sendToNewPage": "發送到新頁面",
    "moveUpLane": "上移泳道",
    "moveDownLane": "下移泳道",
    "moveLeftLane": "左移泳道",
    "moveRightLane": "右移泳道",
    "insertLaneBefore": "向前插入泳道",
    "insertLaneAfter": "向後插入泳道",
    "deleteLane": "刪除泳道",
    "deleteSeparator": "刪除分隔符",
    "showSwimMainTitle": "顯示泳道主標題",
    "mergeBlock": "組合塊",
    "HSplit": "水平分割",
    "VSplit": "豎直分割",
    "expandAllSubTask": "展開所有子任務",
    "collapseAllSubTask": "隱藏所有子任務",
    "moveTasksUp": "向上移動任務",
    "moveTasksDown": "向下移動任務",
    "addSymbolToLibs": "添加到我的符號庫",
    "clearWatermark": "移除浮水印"
  }
}
</i18n>
<template>
    <!-- 图形右键菜单 -->
    <MenuList
        v-if="!isGantt"
        :class="{ 'org-shape-content': isOrgShape }"
        @mouseover.stop
        :style="contextStyle"
        :menuList="menuList"
        @handleClicks="handleClicks(...arguments)"
        @handleMouseenter="handleMouseenter(...arguments)"
    >
        <template #orgPhoto>
            <div class="menu-item" @click="OrgPhoto">
                <span>{{ $t("OrgPhoto") }}</span>
                <input style="display: none" accept=".bmp, .png, .jpg, .jpeg, .gif, .ico" ref="OrgReplaceImg" type="file" @change="getImg($event)" />
            </div>
        </template>
    </MenuList>
    <!-- 甘特图右键菜单 -->
    <GanttRightMenu v-else />

    <!-- <div class='shape-context' @mouseover.stop :style="contextStyle"> -->
    <!-- 旧代码注释部分 👇 -->
    <!-- custom context item -->

    <!-- gantt -->
    <!-- <div class='context-item'>
        Add Task Before
    </div>
    <div class='context-item'>
        Add Task After
    </div>
    <div class='context-item'>
        Sub Task
    </div> -->
    <!--  -->

    <!-- orgChart -->
    <!--     
    <div v-if='isOrgShape' class='menu-item'>
        Add Superordinate
    </div>
    <div v-if='isOrgShape' class='menu-item'>
        Add Subordinate
    </div>
    <div v-if='isOrgShape' :class='{"disabled-item":isOrgShape && !isOrgExistSuper}' class='menu-item'>
        Add Colleague
    </div>
    <div v-if='isOrgShape' class='menu-item'>
        Add Assistant
    </div> -->
    <!--  -->
    <!-- actions list -->
    <!-- <div v-if="actionsList.length != 0 && item.isVisible" v-for="item in actionsList" :key="item.id" class='menu-item' :class='{"disabled-menu-item":!item.isAble, "checked-menu-item": item.isCheck}' @click="item.isAble && clickAction(item.id)">
        <span>{{ item.name }}</span>
    </div>
    <div class='menu-divide' v-if="actionsList.length != 0">
        <hr />
    </div> -->
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject, Watch } from "vue-property-decorator";
    import { EDRAWMAX_USE_CUSTOMLIBRARY } from "@/env/";
    import { aidrawLibs } from "@/app/utils/constant";
    // declare var eGanttType: any;
    enum eGanttType {
        SelectAll,
        NewTask,
        NewSubTask,
        DeleteTask,
        Indent,
        Outdent,
        HideColumn,
        LinkTasks,
        UnlinkTasks,
        Forward,
        Backward,
        GotoTask,
        GotoTaskEnd,
        AddLeftLabel,
        AddRightLabel,
        NewTaskAfter,
        MoveUpTasks,
        MoveDownTasks,
    }
    import appConfig from "@/public/globalConfig";
    import MenuList from "@/app/components/MenuList.vue";
    import GanttRightMenu from "./expandMenus/GanttRightMenu.vue";
    import { InternalLimitTableIds, OverseaLimitTableIds } from "@/app/utils/constant";
    @Component({
        components: {
            MenuList,
            GanttRightMenu,
        },
    })
    export default class shapeContext extends Vue {
        @Inject()
        ["showMessage"];
        showOpenLibrary = !appConfig.isBuild;
        libraryWorkerURL: string = appConfig.libraryWorkerURL;

        get flowAnalyse() {
            return this.$store.state.shape.flowAnalyse;
        }
        get orgShapeAnalyse() {
            return this.$store.state.shape.orgShapeAnalyse;
        }
        get activeText() {
            return this.$store.state.shape.activeText;
        }
        get aiType() {
            const type = this.$store.state.shape.type;
            const map = new Map([
                ["EDChart", "aiChart"],
                ["Table", "aiTable"],
                ["OrgShape", "aiOrgShape"],
            ]);
            if (map.has(type)) {
                return map.get(type);
            } else if (this.flowAnalyse) {
                if (this.activeText) return "aiTextFlowchart";
                return "aiFlowchart";
            } else if (this.orgShapeAnalyse) {
                return "aiOrgShape";
            } else if (this.activeText || this.activeAiSymbol) {
                return "AI";
            } else if (this.isMindmap2) {
                return "aiMindmap2";
            } else {
                return "";
            }
        }
        get limitTableIds() {
            return this.internal ? InternalLimitTableIds : OverseaLimitTableIds;
        }
        get showClearWatermark() {
            const libId = window["_view"] && window["_view"]._activeShape ? window["_view"]._activeShape._libId : "";
            return !this.vip && this.limitTableIds.includes(libId);
        }
        get menuList() {
            let moveLeftUpLabel = this.verticalLane ? this.$t("moveLeftLane") : this.$t("moveUpLane");
            let moveRightLabel = this.verticalLane ? this.$t("moveRightLane") : this.$t("moveDownLane");
            let list = [
                { slot: "orgPhoto", isRender: this.isShowPhoto },
                { key: "RSCnt", isRender: this.canResetCnt },
                { key: "RACnt", isRender: this.canConvertCnt },
                { key: "SLCnt", isRender: this.canConvertCnt },
                { key: "CurveCnt", isRender: this.canConvertCnt },
                // IgnJumpCnt 原代码翻译文案缺失，不明其意
                { key: "IgnJumpCnt", isRender: this.showIgnJump, checked: this.isIgnJump },
                // HP_Door
                { key: "HFlip", isRender: this.canFlip },
                { key: "VFlip", isRender: this.canFlip },
                // mindMap or orgChart
                { key: "drillText", isRender: this.canDrill },
                { key: "stopDrillText", isRender: this.canStopDrill },
                { key: "toggleText", isRender: this.canToggle },
                { key: "stopToggleText", isRender: this.canStopToggle },
                // swimlane
                {
                    key: "moveLeftUp",
                    label: moveLeftUpLabel,
                    isRender: this.isSwimlane && this.isSelectLane,
                    disabled: !this.canMoveUpLane,
                },
                {
                    key: "moveRightDown",
                    label: moveRightLabel,
                    isRender: this.isSwimlane && this.isSelectLane,
                    disabled: !this.canMoveDownLane,
                },
                { key: "insertLaneBefore", isRender: this.isSwimlane && this.isSelectLane },
                { key: "insertLaneAfter", isRender: this.isSwimlane && this.isSelectLane },
                { key: "deleteLane", isRender: this.isSwimlane && this.isSelectLane },
                { key: "deleteSeparator", isRender: this.isSwimlane && this.isSelectSeparator },
                { key: "showSwimMainTitle", isRender: this.isSwimlane, expand: true },
                // multiBlock
                { key: "mergeBlock", isRender: this.isMultiBlock, disabled: !this.canMerge },
                { key: "HSplit", isRender: this.isMultiBlock, disabled: !this.canSplitH },
                { key: "VSplit", isRender: this.isMultiBlock, disabled: !this.canSplitV },
                {
                    divide: true,
                    isRender:
                        this.canDrill ||
                        this.canStopDrill ||
                        this.canToggle ||
                        this.canStopToggle ||
                        this.canFlip ||
                        this.canConvertCnt ||
                        this.isSwimlane ||
                        this.isMultiBlock,
                },
                // common
                { key: "copyText", shortcut: "Ctrl+C" },
                { key: "cutText", shortcut: "Ctrl+X" },
                { key: "pasteText", shortcut: "Ctrl+V", expand: true, hasIcon: true },
                { key: "delText", shortcut: "Backspace" },
                { divide: true },
                { key: "styleBrush", disabled: !this.isSelect },
                { divide: true },
                {
                    key: this.aiType,
                    label: this.$t("AI"),
                    isRender: this.showAIAssist,
                    img: require(`@/app/assets/img/ai4/ai-chat-icon${window.EDCONFIG.IS_SDK ? "-sdk" : ""}.svg`),
                    tag: require("@/app/assets/img/ai/ai-tag.svg"),
                    expand: true,
                    disabled: !this.isSelect,
                },
                { divide: true, isRender: this.showAIAssist },
                {
                    key: "pictureAnalysis",
                    isRender: this.showPictureAnalysis,
                    img: require(`@/app/assets/img/ai4/ai-chat-icon${window.EDCONFIG.IS_SDK ? "-sdk" : ""}.svg`),
                    tag: require("@/app/assets/img/ai/ai-tag.svg"),
                    expand: true,
                },
                { divide: true, isRender: this.showPictureAnalysis },
                {
                    key: "aiImage",
                    isRender: this.isImage,
                    img: require("@/app/assets/floatTool/img/ai/aidraw.svg"),
                    tag: require("@/app/assets/img/ai/ai-tag.svg"),
                    disabled: this.isMultisel || !this.isSelect,
                },
                { divide: true, isRender: this.isImage },
                { key: "replaceShape", expand: true, disabled: this.expandLibraryDataLen == 0 },
                // { key: "clearWatermark", isRender: !this.vip && this.showClearWatermark, showVip: true, hideTippy: true },
                this.lockSomeStatus ? { key: "unprotect" } : { key: "protect" },
                {
                    key: "group",
                    isRender: this.group,
                    shortcut: "Ctrl+G",
                    disabled: !this.group || this.mmShapeMultiState || this.ganttShapeMultiState || this.tableShapeMultiState || this.containOrgShape,
                },
                {
                    key: "unGroup",
                    isRender: this.unGroup,
                    shortcut: "Ctrl+Shift+G",
                    disabled: this.isOrgShape,
                },
                { divide: true },
                { key: "layer", expand: true, show: !this.isMMShape },
                { key: "align", expand: true, show: !this.isMMShape },
                {
                    key: "distribute",
                    expand: true,
                    disabled: !this.isMultiSel || (this.isMultiSel && this.isMMShape),
                },
                {
                    key: "sameSize",
                    expand: true,
                    disabled: !this.isMultiSel || (this.isMultiSel && this.isMMShape),
                },
                { divide: true },
                { key: "insert", expand: true, disabled: this.isMultiSel },
                { key: "shapeData" },
                // 甘特图菜单，已在甘特图右键菜单组件中配置
                // { key: "expandAllSubTask", isRender: this.isGantt, disabled: !this.isExpandAllSubTask },
                // { key: "collapseAllSubTask", isRender: this.isGantt, disabled: !this.isHideAllSubTask },
                // { key: "moveTasksUp", isRender: this.isGantt, disabled: !this.isCanMoveUpTask },
                // { key: "moveTasksDown", isRender: this.isGantt, disabled: !this.isCanMoveDownTask },
                { divide: true },
                {
                    key: "addSymbolToLibs",
                    isRender: this.useCustomLib,
                    expand: true,
                    disabled: this.isMap,
                },
                { key: "moveLayer", expand: true },
                { key: "sendToNewPage", expand: true },
                { key: "clickEvent" },
                { key: "openLibFromShape", isRender: this.showOpenLibrary },
            ];
            let index = list.findIndex((v) => v.key === "pictureAnalysis");
            if (this.internal) {
                list.splice(index, 2);
            }
            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                if (!["moveLeftUp", "moveRightDown"].includes(item.key)) {
                    resultList.push(item.divide ? item : Object.assign({}, { label: this.$t(item.key) }, item));
                }
            });
            return { container: "shape-context", list: resultList };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "RSCnt",
                    () => {
                        this.ResetCnt();
                    },
                ],
                [
                    "RACnt",
                    () => {
                        this.RACnt();
                    },
                ],
                [
                    "SLCnt",
                    () => {
                        this.SLCnt();
                    },
                ],
                [
                    "CurveCnt",
                    () => {
                        this.CurveCnt();
                    },
                ],
                [
                    "IgnJumpCnt",
                    () => {
                        this.IgnJumpCnt();
                    },
                ],
                // HP_Door
                [
                    "HFlip",
                    () => {
                        this.HFlip();
                    },
                ],
                [
                    "VFlip",
                    () => {
                        this.VFlip();
                    },
                ],
                // mindMap or orgChart
                [
                    "drillText",
                    () => {
                        this.drills();
                    },
                ],
                [
                    "stopDrillText",
                    () => {
                        this.stopDrills();
                    },
                ],
                [
                    "toggleText",
                    () => {
                        this.toggles();
                    },
                ],
                [
                    "stopToggleText",
                    () => {
                        this.stopToggles();
                    },
                ],
                // swimlane
                [
                    "moveLeftUp",
                    () => {
                        this.canMoveUpLane && this.swimLaneOperate("moveUp");
                    },
                ],
                [
                    "moveRightDown",
                    () => {
                        this.canMoveDownLane && this.swimLaneOperate("moveDown");
                    },
                ],
                [
                    "insertLaneBefore",
                    () => {
                        this.swimLaneOperate("insertBefore");
                    },
                ],
                [
                    "insertLaneAfter",
                    () => {
                        this.swimLaneOperate("insertAfter");
                    },
                ],
                [
                    "deleteLane",
                    () => {
                        this.swimLaneOperate("deleteLane");
                    },
                ],
                [
                    "deleteSeparator",
                    () => {
                        this.swimLaneSeparatorOperate("deleteSeparator");
                    },
                ],
                // multiBlock
                [
                    "mergeBlock",
                    () => {
                        this.canMerge && this.specialOperate("mergeBlock");
                    },
                ],
                [
                    "HSplit",
                    () => {
                        this.canSplitH && this.specialOperate("splitBlock", 0);
                    },
                ],
                [
                    "VSplit",
                    () => {
                        this.canSplitV && this.specialOperate("splitBlock", 1);
                    },
                ],
                // common
                [
                    "copyText",
                    () => {
                        this.copys();
                    },
                ],
                [
                    "cutText",
                    () => {
                        this.cuts();
                    },
                ],
                [
                    "pasteText",
                    () => {
                        this.pastes(event);
                    },
                ],
                [
                    "delText",
                    () => {
                        this.del();
                    },
                ],
                [
                    "styleBrush",
                    () => {
                        this.stylesBrush();
                    },
                ],
                [
                    "clearWatermark",
                    () => {
                        this.clearWatermark();
                    },
                ],
                [
                    "protect",
                    () => {
                        this.lockShape();
                    },
                ],
                [
                    "unprotect",
                    () => {
                        this.unlockShape();
                    },
                ],
                [
                    "group",
                    () => {
                        this.toGroups();
                    },
                ],
                [
                    "unGroup",
                    () => {
                        this.toUnGroup();
                    },
                ],
                [
                    "shapeData",
                    () => {
                        this.showShapeData();
                    },
                ],
                // 甘特图菜单，已在甘特图右键菜单组件中配置
                // [ "expandAllSubTask", () => { this.ExpandAllSubTask() } ],
                // [ "collapseAllSubTask", () => { this.CollapsedAllSubTask() } ],
                // [ "moveTasksUp", () => { this.MoveUpTasks() } ],
                // [ "moveTasksDown", () => { this.MoveDownTasks() } ],
                [
                    "clickEvent",
                    () => {
                        this.clickEvents();
                    },
                ],
                [
                    "openLibFromShape",
                    () => {
                        this.openShapeLibrary();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }

        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            this.showExp(event, key);
        }
        openShapeLibrary() {
            // 打开符号相应的库，内部使用
            if (!this.showOpenLibrary) return;
            let libID = window["_view"]._activeShape._libId;
            let menu = this.$store.state.library.menuList;
            let downloadList = [];
            let libObj = {};
            let checkbox = this.$store.state.library.checkbox;
            let tempCheckbox = JSON.parse(JSON.stringify(checkbox));

            let getInfoByTableID = (id, menu) => {
                let obj = {
                    tableID: id,
                    name: "",
                    version: "",
                    type: "",
                    mcount: 0,
                    group: "",
                };
                let url = "";
                for (let i = 0; i < menu.length; ++i) {
                    if (menu[i].children.length > 0) {
                        let child = menu[i].children;
                        for (let j = 0; j < child.length; ++j) {
                            if (child[j].id == id) {
                                obj.name = child[j].tableName;
                                obj.version = child[j].version;
                                obj.type = child[j].type;
                                obj.mcount = child[j].mcount;
                                obj.group = menu[i].groupName;
                                url = child[j].url;
                                break;
                            }
                        }
                    }
                }
                return { url: url, data: obj };
            };
            let checkLocalStorage = (libObj, downloadList) => {
                let obj = getInfoByTableID(libID, menu);
                if (obj.url != "") {
                    downloadList.push(obj);
                    if (libObj[obj["data"]["group"]]) {
                        libObj[obj["data"]["group"]].push(libID);
                    } else {
                        libObj[obj["data"]["group"]] = [libID];
                    }
                }
            };
            if (libID > 0) {
                checkLocalStorage(libObj, downloadList);
                if (downloadList.length != 0) {
                    let worker = new Worker(this.libraryWorkerURL);
                    worker.postMessage({
                        type: "openFile",
                        data: downloadList,
                        lang: appConfig.language,
                        urls: this.urls,
                    });
                    worker.onmessage = (e) => {
                        let message = e.data;
                        if (message.type === "loaded") {
                            let keyArr = Object.keys(libObj);
                            for (let name of keyArr) {
                                if (Object.keys(tempCheckbox).includes(name)) {
                                    tempCheckbox[name] = libObj[name];
                                } else {
                                }
                            }
                            this.$store.commit("setLibraryState", {
                                type: "checkbox",
                                data: tempCheckbox,
                            });
                            worker.terminate();
                        }
                    };
                }
            }
            this.closeContext();
        }
        closeContext() {
            this.$store.commit("closeContext");
        }
        get contextStyle() {
            return {
                maxHeight: window.innerHeight,
            };
        }

        toGroups() {
            let view = window["_view"];
            if (this.group) {
                view.group();
                view.setActiveShapeFmt();
                this.closeContext();
            }
        }
        toUnGroup() {
            let view = window["_view"];
            if (this.unGroup) {
                view.unGroup();
                view.setActiveShapeFmt();
                this.closeContext();
            }
        }
        clearWatermark() {
            this.$openBuyPage("removeVipLibraryMark");
        }
        lockShape() {
            window["_view"].protectChanged(-2, true);
            this.closeContext();
        }

        unlockShape() {
            window["_view"].unLock();
            this.closeContext();
        }

        drills() {
            let view = window["_view"];
            if (!view) return;
            view.drill();
            view.setActiveShapeFmt();
            this.closeContext();
        }
        toggles() {
            let view = window["_view"];
            if (!view) return;
            view.toggle();
            view.setActiveShapeFmt();
            this.closeContext();
        }
        stopDrills() {
            let view = window["_view"];
            if (!view) return;
            view.stopDrill();
            view.setActiveShapeFmt();
            this.closeContext();
        }
        stopToggles() {
            let view = window["_view"];
            if (!view) return;
            view.stopToggle();
            view.setActiveShapeFmt();
            this.closeContext();
        }
        cuts() {
            document.execCommand("cut");
            this.closeContext();
        }
        copys() {
            document.execCommand("copy");
            this.closeContext();
        }
        pastes(e: MouseEvent) {
            let view = window["_view"];
            if (!view) return;
            view.paste(e);
            this.closeContext();
        }
        del() {
            let view = window["_view"];
            if (!view) return;
            view.deletes();
            this.closeContext();
        }
        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get isStyleBrushActive() {
            return !!this.$store.state.shape.isStyleBrushActive;
        }
        set isStyleBrushActive(v) {
            this.$store.commit("setShapeStatus", { type: "isStyleBrushActive", data: v });
        }
        stylesBrush() {
            let view = window["_view"];
            if (!view) return;
            if (this.isSelect) {
                this.isStyleBrushActive = !this.isStyleBrushActive;
            }
            view.styleBrush(this.isStyleBrushActive);
            this.closeContext();
        }
        showExpand() {
            this.$store.commit("setStatus", {
                type: "showContextExpand",
                data: true,
            });
        }
        showExp(e: MouseEvent, type: string) {
            let node = <HTMLElement>e.target;
            let ts: any = this;
            ts.$bus.$emit("changeContextType", type, node.offsetTop - (<HTMLElement>node.parentElement).scrollTop);
            if (
                [
                    "swimTitle",
                    "rememberFontStyle",
                    "libraryExpand",
                    "layer",
                    "align",
                    "distribute",
                    "sameSize",
                    "Insert",
                    "addSymbolFromPageToLibs",
                    "mvLayer",
                    "mvPage",
                    "AI",
                    "aiChart",
                    "aiTable",
                    "pictureAnalysis",
                    "aiImage",
                    "aiOrgShape",
                    "aiFlowchart",
                    "aiTextFlowchart",
                    "aiMindmap2",
                ].includes(type)
            ) {
                this.showExpand();
                ts.$bus.$emit("changeExpandPosition");
            }
        }

        showShapeData() {
            let ts: any = this;
            ts.$bus.$emit("changeRightViewActiveKey", "propertyP");
            ts.$bus.$emit("changeRightView", "propertyP", false, "other");
            this.closeContext();
        }
        // ExpandAllSubTask() {
        //     let view = window['_view'];
        //     if(view._activeShape && view._activeShape.toGantt()){
        //         let gantt = view._activeShape.toGantt();
        //         if(!gantt) return;
        //         gantt.ShowOrhideSubTask(false);
        //         this.$store.state.gantt.isHideAllTask = true;
        //         this.$store.state.gantt.isExpandAllTask = false;
        //         this.closeContext();
        //     }
        // }
        // CollapsedAllSubTask() {
        //     let view = window['_view'];
        //     if(view._activeShape && view._activeShape.toGantt()){
        //         let gantt = view._activeShape.toGantt();
        //         console.log('123',gantt.ShowOrhideSubTask(true));
        //         if(!gantt) return;
        //         gantt.ShowOrhideSubTask(true);
        //         this.$store.state.gantt.isHideAllTask = false;
        //         this.$store.state.gantt.isExpandAllTask = true;
        //         this.closeContext();
        //     }
        // }
        // MoveUpTasks(){
        //     let view = window['_view'];
        //     view.ganttOperation(eGanttType.MoveUpTasks, "Move Up Task");
        //     this.closeContext();
        // }
        // MoveDownTasks(){
        //     let view = window['_view'];
        //     view.ganttOperation(eGanttType.MoveDownTasks, "Move Down Task");
        //     this.closeContext();
        // }

        clickEvents() {
            this.closeContext();
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "ClickEvent",
            });
            // window['_view'].clickEvent();
        }
        HFlip() {
            let view = window["_view"];
            if (!view) return;
            view.flipShape(true);
            this.closeContext();
        }
        VFlip() {
            let view = window["_view"];
            if (!view) return;
            view.flipShape(false);
            this.closeContext();
        }
        ResetCnt() {
            let view = window["_view"];
            if (!view) return;
            view.cnntorOperation(0);
            this.closeContext();
        }
        RACnt() {
            let view = window["_view"];
            if (!view) return;
            view.cnntorOperation(1);
            this.closeContext();
        }
        SLCnt() {
            let view = window["_view"];
            if (!view) return;
            view.cnntorOperation(3);
            this.closeContext();
        }
        CurveCnt() {
            let view = window["_view"];
            if (!view) return;
            view.cnntorOperation(2);
            this.closeContext();
        }
        IgnJumpCnt() {
            let view = window["_view"];
            if (!view) return;
            view.cnntorOperation(4);
            this.closeContext();
        }
        OrgPhoto() {
            //let ts:any = this;
            //ts.$bus.$emit('changeRightView','orgchart');
            // (<any>this).$edMessage.success('替换照片')

            (this.$refs.OrgReplaceImg as HTMLInputElement).click();

            this.closeContext();
        }
        getImg(e) {
            let file = e.target.files[0];
            let view = window["_view"];

            if (!file || !view) return;

            view.changeCurrentPicture(file);
            e.target.value = "";
        }
        swimLaneOperate(type) {
            if (!this.isSelectLane) return;
            let view = window["_view"];
            if (!view) return;
            view.setSpecial(type);
            this.closeContext();
        }
        swimLaneSeparatorOperate(type) {
            if (!this.isSelectSeparator) return;
            let view = window["_view"];
            if (!view) return;
            view.setSpecial(type);
            this.closeContext();
        }
        specialOperate(type, num = 0) {
            let view = window["_view"];
            if (!view) return;
            view.setSpecial(type, num);
            this.closeContext();
        }
        // clickAction(id){
        //     window['_view'].fmlDoShapeAction(window['_view']._activeShape, id);
        //     this.closeContext();
        // }

        get lockStatus() {
            return this.$store.state.ui.lockStatus;
        }

        get lockSomeStatus() {
            let lockKeys = Object.keys(this.lockStatus).filter((k) => k !== "Select");
            for (let key of lockKeys) {
                if (this.lockStatus[key]) {
                    return true;
                }
            }
            return false;
        }
        get containOrgShape() {
            return this.$store.state.shape.containOrgShape;
        }
        get expandLibraryDataLen() {
            return this.$store.state.dialog.expandLibraryData && this.$store.state.dialog.expandLibraryData.length;
        }
        get isMultiSel() {
            return this.$store.state.shape.isMultiSel;
        }
        get mmShapeMultiState() {
            return this.$store.state.shape.isAllMMShape;
        }
        get ganttShapeMultiState() {
            return this.$store.state.shape.isAllGanttShape;
        }
        get tableShapeMultiState() {
            return this.$store.state.shape.isAllTableShape;
        }
        get group() {
            return this.$store.state.shape.group;
        }
        get unGroup() {
            return this.$store.state.shape.unGroup;
        }
        get canToggle() {
            return this.$store.state.shape.canToggle;
        }
        get canDrill() {
            return this.$store.state.shape.canDrill;
        }
        get canStopDrill() {
            return this.$store.state.shape.canStopDrill;
        }
        get canStopToggle() {
            return this.$store.state.shape.canStopToggle;
        }
        get canFlip() {
            return this.$store.state.shape.canFlip;
        }
        get canResetCnt() {
            return this.$store.state.shape.canResetCnt;
        }
        get canConvertCnt() {
            return this.$store.state.shape.canConvertCnt;
        }
        get isIgnJump() {
            return this.$store.state.shape.isIgnJump;
        }
        get showIgnJump() {
            return this.$store.state.shape.showIgnJump;
        }
        get isShowPhoto() {
            return this.$store.state.shape.isShowPhoto;
        }
        // get actionsList(){
        //     return this.$store.state.shape.actionsList
        // }
        get isSelectLane() {
            return this.$store.state.shape.isSelectLane;
        }
        get isSelectSeparator() {
            return this.$store.state.shape.isSelectSeparator;
        }
        get canMoveUpLane() {
            return this.$store.state.shape.canMoveUpLane;
        }
        get canMoveDownLane() {
            return this.$store.state.shape.canMoveDownLane;
        }
        get verticalLane() {
            return this.$store.state.shape.verticalLane;
        }
        get isSwimlane() {
            return this.$store.getters.isSwimlane;
        }
        get isMultiBlock() {
            return this.$store.getters.isMultiBlock;
        }
        get canMerge() {
            return this.$store.state.shape.canMerge;
        }
        get canSplitH() {
            return this.$store.state.shape.canSplitH;
        }
        get canSplitV() {
            return this.$store.state.shape.canSplitV;
        }
        get isMMShape() {
            return this.$store.state.shape.isMMShape;
        }
        // get isExpandAllSubTask(){
        //      return this.$store.state.gantt.isExpandAllTask;
        //     // return this.$store.state.shape.type == 'Gantt';
        // }
        // get isHideAllSubTask(){
        //     return this.$store.state.gantt.isHideAllTask;
        // }
        // get isCanMoveUpTask(){
        //     return this.$store.state.gantt.canMoveUpTasks;
        //     console.log("this.$store.state.gantt.canMoveUpTasks",this.$store.state.gantt.canMoveUpTasks)

        // }
        // get isCanMoveDownTask(){
        //     return this.$store.state.gantt.canMoveDownTasks;
        //     console.log("this.$store.state.gantt.canMoveDownTasks",this.$store.state.gantt.canMoveDownTasks)

        // }
        get floatToolList() {
            return this.$store.state.floatTool.floatToolList;
        }
        get isMindmap2() {
            return this.floatToolList.includes("Mindmap") || this.floatToolList.includes("MindmapMini");
        }

        get isAIAssistShape() {
            const type = this.$store.state.shape.type;
            return (
                ["EDChart", "Table", "OrgShape"].includes(type) ||
                this.flowAnalyse ||
                this.orgShapeAnalyse ||
                this.activeText ||
                this.isMindmap2 ||
                this.activeAiSymbol
            );
        }

        get showAIAssist() {
            return this.isAIAssistShape && window.EDCONFIG.AI.ENABLE;
        }

        get showPictureAnalysis() {
            return !this.isAIAssistShape && this.isSelect && window.EDCONFIG.AI.ENABLE;
        }

        get isImage() {
            return this.$store.state.shape.type == "Image";
        }

        get isGantt() {
            return this.$store.state.shape.type == "Gantt";
        }
        get isOrgShape() {
            return this.$store.state.shape.type == "OrgShape";
        }

        get isMap() {
            return this.$store.state.shape.type == "EDChart" && this.$store.state.echart.chartType == "map";
        }
        get isMultisel() {
            return this.$store.state.shape.isMultiSel;
        }
        get useCustomLib() {
            return EDRAWMAX_USE_CUSTOMLIBRARY && window.EDCONFIG.MY_LIBRARY_ENABLE;
        }

        get activeAiSymbol() {
            return aidrawLibs.includes(this.$store.state.shape.fromLibId);
        }
    }
</script>
